var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"symbol-legend"},_vm._l((_vm.legendData),function(legendItem,index){return _c('div',{key:index,staticClass:"legend-item"},[_c('img',{attrs:{"src":legendItem.url}}),_c('span',[_vm._v(_vm._s(legendItem.value))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }